export const setRefresh = (data) => {
    return {
      type: 'SET_REFRESH',
      payload: data
    };
  };